import { ResultSet } from "@cubejs-client/core";

import { AppThunk } from "appThunk";
import { immerable } from "immer";
import { cubeLoad } from "modules/helpers/cube/cubeSlice";
import { logError } from "modules/helpers/logger/loggerSlice";

import { Store } from "modules/customer/tools/product/store";

export class StoreCategory {
    [immerable] = true;

    public readonly id: number;
    public readonly name: string;
    private _isSelected: boolean;

    constructor(
        id: number,
        name: string,
        isSelected: boolean
    ) {
        this.id = id;
        this.name = name;
        this._isSelected = isSelected;
    }

    isSelected() {
        return this._isSelected;
    }

    setIsSelected(isSelected: boolean) {
        this._isSelected = isSelected;
    }

    toggleIsSelected() {
        this._isSelected = !this._isSelected;
    }
}

export const loadStoreCategories = (store?: Store): AppThunk<Promise<StoreCategory[]>> => async (dispatch) => {
    try {
        if (!store) {
            return [];
        }

        const query = {
            dimensions: [
                "StoreCategory.id",
                "StoreCategory.category"
            ],
            filters: [{
                member: "StoreCategory.isRetail",
                operator: "equals",
                values: ["1"]
            }]
        };

        const resultSet = await dispatch(cubeLoad(query)) as unknown as ResultSet;
        const rawData = resultSet.rawData();
        
        return rawData.map(row => {
            const id = Number(row["StoreCategory.id"]);
            const name = row["StoreCategory.category"];
            const isSelected = store.storeCategoryID === id ? true : false;
            return new StoreCategory(id, name, isSelected);
        });
    } catch (error) {
        dispatch(logError("Error loading StoreCategories.", error));
        throw error;
    }
};
